window.onload = function() {
    // 首页初始化
    obj.init();
}

var config = { uid: 0, channel: null, complete: false };

var bindParams = {};

var api = "//api.qcplay.com";

var obj = {
    // 初始化
    init: function() {
        this.preloading(); // 预加载
        this.swiper(); // swiper轮播
        this.userInfo(); // 获取用户信息
        this.bind();
        this.share();
        this.preventInput(); // 阻止页
    },

    // 图片资源预加载
    preloading: function() {
        //图片预加载
        var queue = new createjs.LoadQueue();
        queue.on("progress", function(e) {
            //加载中的进度
            if (e.progress * 100 >= 10) {
                $(".loding_time span").width(parseInt(e.progress * 100) + '%')
            };
            var numbers = e.progress * 100;
            // console.log(numbers);

        }, this);
        queue.on("complete", function(e) {
            //加载完成执行操作
            $('.loding_time').remove();
            $('.preloading').addClass('preloading-ani').fadeOut(1000);
            $('.index').removeClass('landing');
            setTimeout(function() {
                $('.preloading').remove();
                if (!localStorage.getItem('is_cache')) {
                    $('.account-info .info .account').html('请登录');
                    obj.login();
                }
            }, 1000)
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的
            '//static.qcplay.com/snail/zqj-2020/images/m_dt_sz-415c2bd1b7.png',
            '//static.qcplay.com/snail/zqj-2020/images/m_dt_t-3c93eb7544.png',
            '//static.qcplay.com/snail/zqj-2020/images/m_jdt-9a61456b4c.png',
            '//static.qcplay.com/snail/zqj-2020/images/jdt_bg-15c91a01c0.png',
            '//static.qcplay.com/snail/zqj-2020/images/arrow_bottom-c2613ffcdc.png',
            '//static.qcplay.com/snail/zqj-2020/images/arrow_bottom_02-2c665dd156.png',
            '//static.qcplay.com/snail/zqj-2020/images/btn_00-c1910f7484.png',
            '//static.qcplay.com/snail/zqj-2020/images/btn_02-18cbf15801.png',
            '//static.qcplay.com/snail/zqj-2020/images/btn_03-8d4d759a7f.png',
            '//static.qcplay.com/snail/zqj-2020/images/btn_03_02-8d94e8577e.png',
            '//static.qcplay.com/snail/zqj-2020/images/btn_04-d886bff59c.png',
            '//static.qcplay.com/snail/zqj-2020/images/btn_05-b080887810.png',
            '//static.qcplay.com/snail/zqj-2020/images/btn_06-12e309a2a6.png',
            '//static.qcplay.com/snail/zqj-2020/images/btn_07-7197fb9d8e.png',
            '//static.qcplay.com/snail/zqj-2020/images/btn_08-53ecf2c78b.png',
            '//static.qcplay.com/snail/zqj-2020/images/complete-b614724557.png',
            '//static.qcplay.com/snail/zqj-2020/images/content_banner_01-f050bfdf26.png',
            '//static.qcplay.com/snail/zqj-2020/images/dengmi-14f09749b8.png',
            '//static.qcplay.com/snail/zqj-2020/images/handbook_btn-7a24f456df.png',
            '//static.qcplay.com/snail/zqj-2020/images/handbook_img-bf9fdfda91.png',
            '//static.qcplay.com/snail/zqj-2020/images/header_bg-db597313d7.png',
            '//static.qcplay.com/snail/zqj-2020/images/icon_01-5fffa011e9.png',
            '//static.qcplay.com/snail/zqj-2020/images/icon_02-ef88671a9f.png',
            '//static.qcplay.com/snail/zqj-2020/images/icon_03-76a5b5dccd.png',
            '//static.qcplay.com/snail/zqj-2020/images/icon_04-5d8db6d586.png',
            '//static.qcplay.com/snail/zqj-2020/images/pancake_box-8ca870af00.png',
            '//static.qcplay.com/snail/zqj-2020/images/pic_img-101e04d5ce.png',
            '//static.qcplay.com/snail/zqj-2020/images/title_banner-9a823816c5.png',
            '//static.qcplay.com/snail/zqj-2020/images/miyu-26aedfcdc9.png',
            '//static.qcplay.com/snail/zqj-2020/images/index_xx-8f88beace5.png',
            '//static.qcplay.com/snail/zqj-2020/images/miyu_02-895bcf86bf.png',
            '//static.qcplay.com/snail/zqj-2020/images/index_01-dae1dbd02b.jpg',
            '//static.qcplay.com/snail/zqj-2020/images/pop_snail_all-54eb7f7c6a.png',
            '//static.qcplay.com/snail/zqj-2020/images/pop_bg-0b030b5e29.png',
            '//static.qcplay.com/snail/zqj-2020/images/tit_r_all-8d2408478c.png',
            '//static.qcplay.com/snail/zqj-2020/images/jg_all-4085f3ebee.png',
            '//static.qcplay.com/snail/zqj-2020/images/jz_bg-2e1ff8fe64.png',
            '//static.qcplay.com/snail/zqj-2020/images/jz_bg_02-4715a44037.png',
            '//static.qcplay.com/snail/zqj-2020/images/li_bg-9ea2ef762c.png',
            '//static.qcplay.com/snail/zqj-2020/images/li_bg_02-a72a19d8d9.png',
            '//static.qcplay.com/snail/zqj-2020/images/pop_title_all-7b9f4f4299.png',
            '//static.qcplay.com/snail/zqj-2020/images/label_all-b2899fe309.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/dic_01-cf2ef46fca.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/dic_02-cc50496509.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/dic_03-4124bd1f2b.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/dic_04-caf25264f4.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/dic_05-9f6dbf46fa.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/1/01-e662012693.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/1/1-1-9c6e225e0e.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/1/1-2-979d532cf3.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/1/1-3-55c4d08dd7.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/1/1-4-b26668ebb4.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/2/02-ad92a7d54a.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/2/2-1-13cf088e33.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/2/2-2-198bd2152a.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/2/2-3-961293d293.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/2/2-4-78567a304f.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/3/03-01ce004be5.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/3/3-1-2bc7b2a1fa.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/3/3-2-835b56390a.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/3/3-3-69aebacc46.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/3/3-4-43822b8b81.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/4/04-b77fff9bdd.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/4/4-1-f530994f3e.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/4/4-2-db2dc52e99.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/4/4-3-f461320268.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/4/4-4-f83b296d84.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/5/05-be3ffd7916.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/5/5-1-f120e5897a.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/5/5-2-2709b9c954.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/5/5-3-1ee22444f5.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/5/5-4-47d5b448ad.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/6/06-ae9123a55a.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/6/6-1-90eefc56ed.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/6/6-2-8c9a20089f.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/6/6-3-70177f47a7.png',
            '//static.qcplay.com/snail/zqj-2020/images/dice/6/6-4-530462eb20.png'
        ]);
    },

    // 整屏切换
    swiper: function() {
        var swiperH = new Swiper('.swiper-container-h', {
            pagination: '.swiper-pagination-h',
            paginationClickable: true,
            direction: 'vertical',
            resistanceRatio: 0,
            mousewheelControl: true,
            slidesPerView: 'auto',
            onInit: function(swiper) { //Swiper2.x的初始化是onFirstInit
                swiperAnimateCache(swiper); //隐藏动画元素 
                swiperAnimate(swiper); //初始化完成开始动画

            },
            onSlideChangeEnd: function(swiper) {
                swiperAnimate(swiper); //每个slide切换结束时也运行当前slide动画
            },
            onTouchEnd: function(swiper) {
                swiperAnimate(swiper);
            },
        });

        function Ani(btn, page) {
            $(btn).on('click', function() {
                swiperH.slideTo(page, 1000, true);
            });
        };
        var aniLink01 = Ani('.arrow', '2');

        var mySwiper2 = new Swiper('#swiper-container2', { //子swiper
            direction: 'vertical',
            nested: true,
            resistanceRatio: 0,
            slidesPerView: 'auto',
            freeMode: true,
            autoHeight: true,
            observeParents: true,
            observer: true,
        });
    },

    // 游戏帐号信息
    userInfo: function() {
        $.ajax({
            url: api + "/snail/login/userinfo",
            type: "GET",
            xhrFields: { withCredentials: true },
            error: function() {
                layer.msg("很抱歉，当前服务器繁忙，请稍候再试");
            },
            success: function(json) {
                // 如果账号没登录，先跳转去登录
                if (json.code == 302) {
                    layer.load(1);
                    var ua = navigator.userAgent.toLowerCase();
                    if (ua.match(/MicroMessenger/i) == "micromessenger") {
                        // 如果在微信里面
                        window.location.href = api + '/wechat/oauth/?callback=' + encodeURI(window.location.href);
                        return;
                    } else {
                        // 如果在QQ里面
                        window.location.href = api + '/qq/oauth/?callback=' + encodeURI(window.location.href);
                        return;
                    }
                }

                // 设置头像信息
                $('.account-info .pic img').attr('src', json.data.avatar);
                // 设置昵称

                if (json.data.role_name == null || json.data.role_name == "" || !localStorage.getItem('is_cache')) {
                    $('.account-info .info .account').html('请登录');
                } else {
                    $('.account-info .info .account').html(json.data.role_name + '<br/>' + json.data.area_name + '&nbsp;' + json.data.server_id + '服');
                }
                // 设置绑定状态
                $('.account-info .tab-acco').removeClass('tab-change')
                if (json.data.channel && localStorage.getItem('is_cache')) {
                    $('.account-info .tab-acco').addClass('tab-change');
                }
                // 剩余次数
                $('.current-numbel').html(json.data.count);
                // 累积积分
                $('.integral').html(json.data.score);
                obj.integral();

                // 助力榜
                $('.helper-count').html(json.data.helper_list.length);
                var $helperList = $('.helper-list');
                if (json.data.helper_list.length == 0) {
                    $helperList.addClass('list-ul-null');
                } else {
                    $helperList.removeClass('list-ul-null');
                }
                $helperList.html('');
                for (var key in json.data.helper_list) {
                    var value = json.data.helper_list[key];
                    var className = "";
                    switch (value.rank_name) {
                        case '未中':
                            className = "li-00";
                            break;
                        case '一秀':
                            className = "li-01";
                            break;
                        case '二举':
                            className = "li-02";
                            break;
                        case '三红':
                            className = "li-04";
                            break;
                        case '四进':
                            className = "li-03";
                            break;
                        case '对堂':
                            className = "li-05";
                            break;
                        case '状元':
                        case '五子登科':
                        case '五王':
                        case '遍地锦':
                        case '六杯红':
                        case '状元插金花':
                            className = "li-06";
                            break;
                    }


                    var createdAt = value.created_at.split(' ');
                    var date = createdAt[0].split('-');
                    var time = createdAt[1].split(':');
                    var helpTime = date[1] + "/" + date[2] + " " + time[0] + ":" + time[1];


                    var $li = $('<li class="' + className + '"></li>');
                    $li.append('<div class="pic"><img src="' + value.user_info.avatar + '"></div>')
                    $li.append('<div class="det"><div class="det"><span class="name">' + value.user_info.nickname + '</span><span class="time">' + helpTime + '</span></div></li>')

                    $helperList.append($li);
                }


                // 设置用户状态
                config.uid = json.data.uid;
                config.channel = json.data.channel;
                config.complete = true;

                // 分享设置
                obj.share();
            }
        })
    },

    // 进行
    login: function() {
        // 初始化打开状态
        $('.inp-account').val('');
        $('.inp-password').val('');
        $('.register-popup').fadeIn();
        openA();
        //  开启动画
        function openA() {
            setTimeout(function() {
                $('.popup_box').addClass('ani');
            }, 200);
        }
    },

    serverInfo: function() {
        // 初始化打开状态
        $('.tab-server').show();
        $('.tab-server').find('.active').removeClass('active');
        $('.tab-server').find('div:first').addClass('active');
        $('.gzf').addClass('show');
        $('.zsf').removeClass('show');
        $('input[name=gzf_role_name]').val('');
        $('input[name=zsf_role_name]').val('');

        // 初始化参数状态
        bindParams = {};

        var index = layer.load(1);
        $.ajax({
            url: api + '/snail/server/qcgame',
            type: "GET",
            xhrFields: { withCredentials: true },
            error: function() {
                layer.msg("很抱歉，当前服务器繁忙，请稍候再试");
            },
            success: function(json) {
                if (json.code != 200) {
                    layer.msg(json.message);
                    return;
                }

                var gzf = json.data[26];
                var zsf = json.data[39];

                if (!gzf && !zsf) {
                    layer.msg("查无您的角色信息");
                    return;
                } else if (!gzf || !zsf) {
                    $('.tab-server').hide();
                } else {
                    $('.tab-server').show();
                }

                if (gzf) {
                    $('.gzf select').html('<option value="">请选择区组</option>');
                    var list = gzf.android;
                    for (var key in list) {
                        var value = list[key];
                        $('.gzf select').append('<option data-dist-number="' + value['dist_number'] + '" data-dist-name="' + value['dist_name'] + '" data-rid="' + value['rid'] + '" data-zone="' + value['zone'] + '" data-role-name="' + value['nickname'] + '">' + value['dist_number'] + '服-' + value['dist_name'] + '</option>')
                    }

                    $('.gzf select').off('change').on('change', function() {
                        var option = $(this).find('option:selected');
                        if (option.val()) {
                            // 改值
                            $('input[name=gzf_role_name]').val($(this).find('option:selected').attr('data-role-name'));
                            bindParams = {
                                game_id: 26,
                                server_name: option.attr('data-dist-number'),
                                role_name: option.attr('data-role-name'),
                                zone: option.attr('data-zone'),
                                rid: option.attr('data-rid'),
                                dist_name: option.attr('data-dist-name'),
                                dist_number: option.attr('data-dist-number'),
                                type: "android"
                            }
                        } else {
                            // 清空
                            $('input[name=gzf_role_name]').val('');
                            bindParams = {};
                        }

                    })

                } else {
                    $('.gzf').removeClass('show');
                }

                if (zsf) {
                    // 如果没有光子服就显示
                    gzf ? $('.zsf').removeClass('show') : $('.zsf').addClass('show');

                    // 初始化内容
                    $('.zsf-os').html('<option value="">请选择手机系统</option>')
                    $('.zsf-server').html('<option value="">请选择区服</option>')

                    // 拼接手机系统
                    for (var key in zsf) {
                        $('.zsf-os').append('<option value="' + key + '">' + key + '</option>')
                    }

                    // 手机系统选择
                    $('.zsf-os').off('change').on('change', function() {

                        bindParams = { game_id: 39, type: $(this).val() }

                        var role = zsf[$(this).val()];
                        // 区服下拉框设置为空
                        $('.zsf-server').html('<option value="">请选择区服</option>');
                        // 角色信息为空
                        $('.zsf-role').val('');
                        // 拼接区服下拉框
                        for (var key in role) {
                            var value = role[key];
                            $('.zsf-server').append('<option data-dist-number="' + value['dist_number'] + '" data-dist-name="' + value['dist_name'] + '" data-rid="' + value['rid'] + '" data-zone="' + value['zone'] + '" data-server-name="' + value['dist_name'] + '" data-role-name="' + value['nickname'] + '">' + value['dist_number'] + '服-' + value['dist_name'] + '</option>')
                        }

                        // 响应区服下拉框事件
                        $('.zsf-server').on('change', function() {
                            var option = $(this).find('option:selected');
                            if (option.val()) {
                                $('.zsf-role').val(option.attr('data-role-name'))
                                bindParams.server_name = option.attr('data-dist-number')
                                bindParams.role_name = option.attr('data-role-name')
                                bindParams.zone = option.attr('data-zone')
                                bindParams.rid = option.attr('data-rid')
                                bindParams.dist_name = option.attr('data-dist-name')
                                bindParams.dist_number = option.attr('data-dist-number')
                            } else {
                                $('.zsf-role').val('');
                                bindParams = { game_id: 39, type: $(this).val() }
                            }
                        });
                    })

                } else {
                    $('.zsf').removeClass('show');
                }


                $('.inp-account').val(''); // 账号密码清空
                $('.inp-password').val(''); // 账号密码清空
                $('.register-popup').fadeOut(); // 关闭登陆页面
                $('.server-popup').fadeIn(); // 开启服务器
                $('.popup_box').addClass('ani');
            },
            complete: function() {
                layer.close(index);
            }
        });
    },

    // 获取url参数
    getQueryVariable: function(variable) {
        var href = window.location.href + "";
        var query = href.split('?')[1];
        if (!query) {
            return ""
        }
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) { return pair[1]; }
        }
        return "";
    },

    share: function() {
        $.ajax({
            url: api + "/wechat/jssdk",
            type: "POST",
            data: {
                uri: window.location.href,
            },
            success: function(json) {

                // 此刻分享的页面
                var time = new Date()
                var year = "2020";
                var month = time.getMonth() + 1;
                month = month < 10 ? "0" + month : month;
                var day = time.getDate();
                day = day < 10 ? "0" + day : day;
                var hour = time.getHours();
                hour = hour < 10 ? "0" + hour : hour;
                var minute = time.getMinutes()
                var minute = parseInt(minute / 10) * 10;
                minute = minute < 10 ? "00" : minute;
                var file = year + month + day + hour + minute;

                var ua = navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                    wx.config(json.data);
                    wx.ready(function() {
                        wx.updateAppMessageShareData({
                            title: '中秋博饼,助我提名', // 分享标题
                            desc: '快来帮蜗摇骰子！', // 分享描述
                            link: 'https://static.qcplay.com/snail/zqj-2020/' + file + '.html?uid=' + config.uid, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: 'https://static.qcplay.com/common/share.jpg', // 分享图标
                            success: function() {}
                        })

                        wx.updateTimelineShareData({
                            title: '中秋博饼,助我提名', // 分享标题
                            link: 'https://static.qcplay.com/snail/zqj-2020/' + file + '.html?uid=' + config.uid, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: 'https://static.qcplay.com/common/share.jpg', // 分享图标
                            success: function() {
                                // 设置成功
                            }
                        })
                    });
                    return;
                } else {
                    try {
                        setShareInfo({
                            title: '中秋博饼,助我提名', // 分享标题
                            summary: '快来帮蜗摇骰子！', // 分享内容
                            pic: 'https://static.qcplay.com/common/share.jpg', // 分享图片
                            url: 'https://static.qcplay.com/snail/zqj-2020/' + file + '.html?uid=' + config.uid, // 分享链接
                            // 微信权限验证配置信息，若不在微信传播，可忽略
                            WXconfig: {
                                swapTitleInWX: true, // 是否标题内容互换（仅朋友圈，因朋友圈内只显示标题）
                                appId: json.data.appId, // 公众号的唯一标识
                                timestamp: json.data.timestamp, // 生成签名的时间戳
                                nonceStr: json.data.nonceStr, // 生成签名的随机串
                                signature: json.data.signature // 签名
                            }
                        });
                    } catch (err) {}
                }
            }
        })
    },

    bind: function() {

        //  开启动画
        function openA() {
            setTimeout(function() {
                $('.popup_box').addClass('ani');
            }, 200);
        }

        // 关闭动画
        function close() {
            $('.popup').fadeOut().find('.popup_box').removeClass('ani');
        }

        // 点击弹窗背景关闭弹窗-通用
        $('.close-bg').click(function(event) {
            close();
        });

        // 仅用博饼后的关闭
        $('.prize-popup .close-bg').click(function(event) {
            for (var i = 5; i >= 0; i--) {
                $('.prize-popup').removeClass('status-0' + i + '');
            };
        });

        // 点击查看活动详情
        $('.act-btn').click(function(event) {
            $('.introduce-popup').fadeIn();
            openA();
        });

        // 猜灯谜
        $('.miyu-btn').click(function(event) {
            var _this = $(this);
            if (_this.attr('data') == 2) {
                $('.miyu-popup .int-main h3').html('般若般罗密');
                $('.miyu-popup .int-main p').html('（打一贵重品）');
            } else {
                $('.miyu-popup .int-main h3').html('门口一人和一虫，正午时分探出头');
                $('.miyu-popup .int-main p').html('（打一生物）');
            }
            $('.miyu-popup').fadeIn();
        });

        // 关闭灯谜
        $('.miyu-popup').click(function(event) {
            $('.miyu-popup').fadeOut().find('.inf').html('');
        });

        // tab切换（青瓷登录 or b站）
        $('.introduce-box .label-main').on('click', 'div', function(event) {
            $(this).addClass('select').siblings().removeClass('select').parent('.label-main').siblings().children('.int-box').eq($(this).index()).addClass('show').siblings().removeClass('show');
        });

        $('.big-img').click(function(event) {
            $('.big-img-popup').fadeIn();
        });

        // 点击关闭大图
        $('.big-img-popup img').click(function(event) {
            $('.big-img-popup').fadeOut();
        });

        // 点击查看博饼图鉴
        $('.handbook-btn').click(function(event) {
            if (satisfy) {
                return;
            }
            $('.handbook-popup').fadeIn();
            openA();
        });

        // 点击分享
        $('.share-btn').on('click', function() {
            // 未登录先登录
            if (!config.channel) {
                obj.login();
                openA();
                return;
            }
            if (satisfy) {
                return;
            }
            // if (config.account == "") {
            //     obj.login();
            //     return;
            // }
            $('.share-popup').fadeIn();
            openA();
        });

        // 关闭分享
        $('.share-popup').on('click', function() {
            $('.share-popup').fadeOut();
        });


        // 摇奖
        var countNum = 1;
        var currentNum = 0;

        var satisfy = false;
        $('.pancake-btn').click(function(event) {
            // 未登录先登录
            if (!config.channel) {
                obj.login();
                openA();
                return;
            }
            if ($('.current-numbel').html() == 0) {
                layer.msg("很抱歉，今日已经没有次数了");
                return;
            }
            if (satisfy) {
                return;
            }
            satisfy = true;

            var index = layer.load(1);
            $.ajax({
                url: api + "/snail/mid-autumn/lottery",
                type: "POST",
                xhrFields: { withCredentials: true },
                error: function() {
                    satisfy = false;
                    layer.msg("很抱歉，当前服务器繁忙，请稍候再试");
                },
                success: function(json) {
                    if (json.code != 200) {
                        layer.msg(json.message);
                        return;
                    }

                    $('.current-numbel').html(json.data.count);
                    setTimeout(function() {
                        $('.integral').html(json.data.score);
                        obj.integral();
                    }, 3000);
                    shock(); // 微信震动
                    randomX(json.data); // 随机数
                    winOneWrap(); // 单次抽奖渲染
                },
                complete: function() {
                    setTimeout(function() {
                        satisfy = false;
                    }, 3500);
                    layer.close(index);
                }
            })
        });

        // 微信-震动效果
        function shock() {
            if (navigator.vibrate) {
                navigator.vibrate(500);
            } else if (navigator.webkitVibrate) {
                navigator.webkitVibrate(500);
            }
        }

        // 随机数
        var aniX, face1, face2, face3, face4, face5, face6, dice1, dice2, dice3, dice4, dice5, dice6;

        function randomX(data) {
            $('.bg-img').addClass('bg-off-ani'); // 移除帮助页面的动画效果
            $('.bowl-box .shine').hide();
            $('.cake-sieve ul').remove(); // 清除筛子在碗里的位置
            $('.scroll ul li').remove(); // 清除当前弹窗的信息
            aniX = GetRandomdice(1, 3);
            // 四种角度面
            face1 = GetRandomdice(1, 4);
            face2 = GetRandomdice(1, 4);
            face3 = GetRandomdice(1, 4);
            face4 = GetRandomdice(1, 4);
            face5 = GetRandomdice(1, 4);
            face6 = GetRandomdice(1, 4);
            // 六种输出随机数
            dice1 = data.sort[0];
            dice2 = data.sort[1];
            dice3 = data.sort[2];
            dice4 = data.sort[3];
            dice5 = data.sort[4];
            dice6 = data.sort[5];

            switch (data.rank) {
                case 'wz':
                    $('.prize-popup').addClass('status-00');
                    break;
                case 'yx':
                    $('.prize-popup').addClass('status-01');
                    break;
                case 'ej':
                    $('.prize-popup').addClass('status-02');
                    break;
                case 'sj':
                    $('.prize-popup').addClass('status-04');
                    break;
                case 'sh':
                    $('.prize-popup').addClass('status-03');
                    break;
                case 'dt':
                    $('.prize-popup').addClass('status-05');
                    break;
                case 'zy':
                case 'wzdk':
                case 'ww':
                case 'bdj':
                case 'lbh':
                case 'cjh':
                    $('.prize-popup').addClass('status-06');
                    break;
            }

            // 骰子的动画执行
            sieveAni();

        }

        // 骰子-随机数
        function GetRandomdice(Min, Max) {

            var Range = Max - Min;
            var Rand = Math.random();
            return (Min + Math.round(Rand * Range));

        }

        // 骰子-结果渲染
        function sieveAni() {

            var addHTML = '<ul class="ani-' + aniX + '">' +
                '<li class="sieve animation-1 point-' + dice1 + '-' + face1 + ' one">' + dice1 + '</li>' +
                '<li class="sieve animation-2 point-' + dice2 + '-' + face2 + ' two">' + dice2 + '</li>' +
                '<li class="sieve animation-3 point-' + dice3 + '-' + face3 + ' three">' + dice3 + '</li>' +
                '<li class="sieve animation-4 point-' + dice4 + '-' + face4 + ' four">' + dice4 + '</li>' +
                '<li class="sieve animation-5 point-' + dice5 + '-' + face5 + ' five">' + dice5 + '</li>' +
                '<li class="sieve animation-6 point-' + dice6 + '-' + face6 + ' six">' + dice6 + '</li>' +
                '</ul>';
            $('.cake-sieve').append(addHTML);

        }

        // 一次抽奖
        function winOneWrap() {
            setTimeout(function() {
                $('.bowl-box .shine').fadeIn();
                setTimeout(function() {
                    $('.prize-popup').fadeIn();
                    openA();
                }, 500);
            }, 2000);
            // 随机效果渲染
            var addPoint = '<li class="sieve-0' + dice1 + '"></li>' +
                '<li class="sieve-0' + dice2 + '"></li>' +
                '<li class="sieve-0' + dice3 + '"></li>' +
                '<li class="sieve-0' + dice4 + '"></li>' +
                '<li class="sieve-0' + dice5 + '"></li>' +
                '<li class="sieve-0' + dice6 + '"></li>';
            $('.scroll ul').append(addPoint);

            // ajax
            // function ajaxData(countNum) {
            //     $.ajax({
            //         type : "post",
            //         url: 'http://account.qcplay.com/activity.php/Bobing/post',
            //         data:{frequency:countNum},
            //         dataType: 'json',
            //         success: function(json) {
            //             console.log(json);
            //         }
            //     })
            // }

            // 效果如下:
            // 请求接口-弹窗 
            // 1 - 一秀弹窗
            // 2 - 二举弹窗
            // 3 - 三红弹窗
            // 4 - 四进弹窗
            // 5 - 对堂弹窗
            // 6 - 状元弹窗
            // var diceResults = 1;
            // $('.prize-popup').addClass('status-0' + diceResults + '');
        }



        // 新页面帮助好友修筑进度---
        $('.help-btn').click(function(event) {
            $(".progress-popup").fadeIn().addClass('progress-step-popup');
            $(".popup_box").addClass("ani");
        });

        $('.register-box .title').on('click', 'div', function(event) {
            $(this).addClass('active').siblings().removeClass('active').parent('.title').siblings('.form-main').children('.form').eq($(this).index()).addClass('show').siblings().removeClass('show');
        });

        $('.register-tab-title').on('click', 'h2', function(event) {
            $(this).addClass('select').siblings().removeClass('select').parent('.register-tab-title').siblings('.register-tab-box').children('.register-box').eq($(this).index()).addClass('show').siblings().removeClass('show');
        });

        $('.tab-server').on('click', 'div', function(event) {
            $(this).addClass('active').siblings().removeClass('active').parent('.tab-server').siblings('.option-main').children('.option-box').eq($(this).index()).addClass('show').siblings().removeClass('show');

            $('.gzf select').val('')
            $('.gzf input[name=gzf_role_name]').val('')
            $('.zsf-os').val('')
            $('.zsf-server').val('')
            $('.zsf input[name=zsf_role_name]').val('');

            bindParams = {
                game_id: $(this).parent().find('.active').attr('data-game-id'),
                server_name: "",
                role_name: "",
                zone: "",
                rid: "",
                dist_name: "",
                dist_number: "",
                type: ""
            }
        });

        // b站游戏角色登录
        $('.binding-btn').click(function() {
            // CZ9SGDZDXRS360
            // 穿越者11262
            var roleName = $('.inp-role-name').val();
            var roleId = $('.inp-role-id').val();

            if (roleName == "") {
                layer.msg("请输入角色名称");
                return
            }
            if (roleId == "") {
                layer.msg("请输入角色ID");
                return
            }

            var index = layer.load(1);
            $.ajax({
                url: api + "/snail/login/bilibili",
                type: "POST",
                data: {
                    role_id: roleId,
                    role_name: roleName
                },
                xhrFields: { withCredentials: true },
                error: function() {
                    layer.msg("很抱歉，当前服务器繁忙，请稍候再试");
                },
                success: function(json) {
                    layer.msg(json.message);
                    if (json.code != 200) {
                        return;
                    }

                    // 清空填写的内容
                    $('.inp-role-name').val('');
                    $('.inp-role-id').val('');

                    // 刷新用户信息
                    localStorage.setItem('is_cache', true);
                    obj.userInfo();

                    close();
                },
                complete: function() {
                    layer.close(index);
                }
            })
        });

        $('.sms-login').click(function() {
            var account = $('.phone-inp').val();
            var code = $('input[name=sms_code]').val();

            var index = layer.load(1);
            $.ajax({
                url: api + '/snail/login/sms',
                type: "POST",
                xhrFields: { withCredentials: true },
                data: {
                    game_id: 39,
                    account: account,
                    sms_code: code
                },
                error: function() {
                    layer.msg("很抱歉，当前服务器繁忙，请稍候再试");
                },
                success: function(json) {
                    // 错误弹窗
                    if (json.code != 200) {
                        layer.msg(json.message);
                        return;
                    }

                    // 打开区服选择器
                    obj.serverInfo();

                    // 清空输入
                    $('.phone-inp').val('');
                    $('input[name=sms_code]').val('');
                },
                complete: function() {
                    layer.close(index)
                }
            })
        })

        var changeBtn = true;
        $('.gift-main').on('click', '.receive-btn', function() {
            if ($(this).hasClass('on')) {
                layer.msg('您已经领取过了~');
                return false;
            }
            if (changeBtn == true) {
                changeBtn = false;
                var $that = $(this);
                var index = layer.load(1);
                $.ajax({
                    url: api + "/snail/zqwn/package",
                    type: "POST",
                    xhrFields: { withCredentials: true },
                    data: {
                        package_id: $(this).attr('data-package-id')
                    },
                    error: function() {
                        layer.msg("很抱歉，当前服务器繁忙，请稍候再试");
                    },
                    success: function(json) {
                        layer.msg(json.message);
                        if (json.code == 200) {
                            $that.addClass('on').html('已领取');
                        }
                    },
                    complete: function() {
                        layer.close(index);
                        setTimeout(function() { changeBtn = true }, 500);
                    }
                })
            }
        })

        // 点击切换账号按钮
        $('.tab-acco').click(function(event) {
            // 如果是b站的想切换帐号
            if (config.channel == 'bilibili') {
                $('.register-tab-title h2:nth-child(2)').addClass('select').siblings().removeClass('select');
                $('.register-tab-box .register-box:nth-child(2)').addClass('show').siblings().removeClass('show');
                obj.login();
                openA()
            } else if (config.uid && config.channel == 'qcplay' && localStorage.getItem('is_cache')) {
                obj.serverInfo()
            } else {
                $('.register-tab-title h2:nth-child(1)').addClass('select').siblings().removeClass('select');
                $('.register-tab-box .register-box:nth-child(1)').addClass('show').siblings().removeClass('show');
                obj.login();
                openA()
            }
        });

        // 注销
        $('.cancell-btn').click(function(event) {
            var index = layer.load(1)
            $.ajax({
                url: api + "/snail/logout",
                type: "POST",
                xhrFields: { withCredentials: true },
                error: function() {
                    layer.msg("很抱歉，当前服务器繁忙，请稍候再试");
                },
                success: function(json) {
                    layer.msg(json.message);
                    if (json.code == 200) {
                        obj.userInfo();
                        obj.login();
                        openA()
                    }
                },
                complete: function() {
                    layer.close(index)
                }
            });
            $('.popup').fadeOut();
        });

        // 确认
        $('.confirm-btn').click(function(event) {
            if (bindParams.rid == undefined) {
                layer.msg("请先选择信息");
                return false;
            }

            var index = layer.load(1);
            $.ajax({
                url: api + "/snail/server/qcgame",
                type: "POST",
                xhrFields: { withCredentials: true },
                data: {
                    account: config.account,
                    ...bindParams
                },
                error: function() {
                    layer.msg("很抱歉，当前服务器繁忙，请稍候再试");
                },
                success: function(json) {
                    layer.msg(json.message);
                    if (json.code == 200) {
                        localStorage.setItem('is_cache', true);
                        obj.userInfo();
                        $('.popup').fadeOut();
                    }
                },
                complete: function() {
                    layer.close(index)
                }
            });
        });

        // 验证码判断
        $('.obtain-verification').on('click', 'a', function(event) {
            var phone = $('.phone-inp');
            if (!phone.val()) {
                layer.msg("请输入手机号", { time: 2000 });
                phone.focus();
                return false;
            }

            var index = layer.load(1);
            $.ajax({
                url: api + '/snail/login/sms/send',
                type: "POST",
                xhrFields: { withCredentials: true },
                data: {
                    mobile: phone.val(),
                    channel: "login"
                },
                error: function() {
                    layer.msg("很抱歉，当前服务器繁忙，请稍候再试");
                },
                success: function(json) {
                    if (json.code != 200) {
                        layer.msg(json.message);
                        return;
                    } else {
                        // 倒计时
                        time();
                    }
                },
                complete: function() {
                    layer.close(index)
                }
            });
        });

        $('.register-btn').click(function(event) {
            /* Act on the event */
            var account = $('.inp-account').val();
            var password = $('.inp-password').val();
            if (account == '') {
                layer.msg("请输入您的账号", { time: 2000 });
                return false;
            }
            if (password == '') {
                layer.msg("请输入您的密码", { time: 2000 });
                return false;
            }

            var index = layer.load(1);
            $.ajax({
                url: api + "/snail/login/account",
                type: "POST",
                xhrFields: { withCredentials: true },
                data: {
                    account: account,
                    password: password,
                    game_id: 39
                },
                error: function() {
                    layer.msg("很抱歉，当前服务器繁忙，请稍候再试");
                },
                success: function(json) {
                    // 如果登录失败
                    if (json.code != 200) {
                        layer.msg(json.message);
                        return;
                    }

                    // 打开区服选择框
                    obj.serverInfo();

                    // 清空输入
                    $('.inp-account').val('');
                    $('.inp-password').val('');
                },
                complete: function() {
                    layer.close(index);
                }
            })
        });


        // 60s倒计时
        var wait = 60;

        function time() {
            if (wait == 0) {
                $('.obtain-verification span a').remove();
                $('.obtain-verification span').html("<a>发送</a>");
                wait = 60;
            } else {
                $('.obtain-verification span a').remove();
                $('.obtain-verification span').html("<b>" + wait + "秒</b>");
                wait--;
                setTimeout(function() {
                    time()
                }, 1000)
            }
        }
    },

    progress: function(dataNum) {
        $('.pro-jdt div').css({ 'width': dataNum + '%' });
        $(".progress-popup").find('.success-div').addClass('success-div-' + dataNum + '');
        $('.jdt-bg').addClass('jdt-' + dataNum + '').find('b').find('span').html(dataNum);
        $('.jdt-bg').find('div').find('span').css({ 'width': dataNum + '%' });
        if (dataNum == 100) {
            $('.goods-list').addClass('goods-list-03');
            $('.ani-box-bg').addClass('ani-box-100');
            return
        }
        if (dataNum >= 60 && dataNum < 100) {
            $('.goods-list').addClass('goods-list-02');
            $('.ani-box-bg').addClass('ani-box-60');
            return
        }
        if (dataNum >= 20 && dataNum < 60) {
            $('.goods-list').addClass('goods-list-01');
            $('.ani-box-bg').addClass('ani-box-20');
            return
        }
    },

    // 阻止默认页面弹起影响触摸位置
    preventInput: function() {
        $("input").blur(function() {
            setTimeout(function() {
                var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
                window.scrollTo(0, Math.max(scrollHeight - 1, 0));
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            }, 100);
        });
    },

    integral: function() {
        var integralNum = $('.integral').html();
        var list = $('.list-ul');
        var classList = ['00', '05', '10', '15', '20', '30', '40', '50', '60', '70', '80', '90', '100'];
        for (var key in classList) {
            list.removeClass("list-integral-" + classList[key]);
        }
        if (integralNum >= 100) list.addClass('list-integral-100')
        if (integralNum < 100 && integralNum >= 90) list.addClass('list-integral-90');
        if (integralNum < 90 && integralNum >= 80) list.addClass('list-integral-80');
        if (integralNum < 80 && integralNum >= 70) list.addClass('list-integral-70');
        if (integralNum < 70 && integralNum >= 60) list.addClass('list-integral-60');
        if (integralNum < 60 && integralNum >= 50) list.addClass('list-integral-50');
        if (integralNum < 50 && integralNum >= 40) list.addClass('list-integral-40');
        if (integralNum < 40 && integralNum >= 30) list.addClass('list-integral-30');
        if (integralNum < 30 && integralNum >= 20) list.addClass('list-integral-20');
        if (integralNum < 20 && integralNum >= 15) list.addClass('list-integral-15');
        if (integralNum < 15 && integralNum >= 10) list.addClass('list-integral-10');
        if (integralNum < 10 && integralNum >= 5) list.addClass('list-integral-05');
        if (integralNum < 5) list.addClass('list-integral-00');
    }
}